module.exports = __webpack_public_path__ + "static/productions_eclairees-2439a88aba78f54b44c56808f3a83837.mp4";